import React from 'react';
import styled from 'styled-components';
import { Text } from '@catalogo/theme-text';
import AmeIcon from '@catalogo/ui-americanas-desktop-svg/ame.svg';

const Wrapper = styled.div`
  display: block;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  margin-top: 24px;
  padding: 16px;
`;

const TextUI = styled(Text)`
  font-size: 12px;

  &:nth-child(2) {
    margin-top: 4px;
  }
`;

const SuperCashbackBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0 5px;
  margin-bottom: 5px;
`;

const SuperCashbackText = styled(Text)`
  font-size: 12px;
  color: ${({ theme }) => theme.card.ame};
`;

const CashbackBox = styled.div`
  display: flex;
`;

const IconWrapper = styled.div`
  min-width: 20px;
  margin-right: 5px;
`;

const CashbackTextWrapper = styled.div`
  display: block;
`;

const AmeIconUI = styled(AmeIcon)`
  width: 20px;
  height: 20px;
  margin-top: ${({ marginTop }) => marginTop};
`;

export const AmeBox = ({ cashback }) => {
  if (!cashback?.cashbacks[0]) {
    return null;
  }

  return (
    <Wrapper>
      {cashback?.supercashbackText && (
        <SuperCashbackBox>
          <AmeIconUI />
          <SuperCashbackText>{cashback?.supercashbackText}</SuperCashbackText>
        </SuperCashbackBox>
      )}
      <CashbackBox>
        {!cashback?.supercashbackText && (
          <IconWrapper>
            <AmeIconUI marginTop="-1px" />
          </IconWrapper>
        )}
        <CashbackTextWrapper>
          {cashback?.cashbacks.map(cashback => (
            <TextUI as="p" key={cashback} dangerouslySetInnerHTML={{ __html: cashback }} />
          ))}
        </CashbackTextWrapper>
      </CashbackBox>
    </Wrapper>
  );
};

export default AmeBox;
